import { useMemo } from "react";
import { t, getLocale, setLocale, type Locale } from "@/lib/i18n";

export function useTranslation() {
  const locale = useMemo(() => getLocale(), []);
  
  return {
    t,
    locale,
    setLocale: (newLocale: Locale) => {
      setLocale(newLocale);
    },
  };
}

